import { render, staticRenderFns } from "./HistoriqueInterne.vue?vue&type=template&id=2654f5ce&"
import script from "./HistoriqueInterne.vue?vue&type=script&lang=js&"
export * from "./HistoriqueInterne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports